import { GmgTheme, IconArrowDropDown14, IconArrowRightSmall, IconFolderFilled, Spinner } from '@gmg/gmg-react-components';
import { FC } from 'react';
import styled, { useTheme } from 'styled-components';
import { Tr } from '../../shared/TableStyle';
import { FolderListItem } from '../../viewModels/Folder';
import DataManagementActions from './DataManagementActions';

export interface FolderRowProps {
    folder: FolderListItem;
    isLoading: boolean;
    onToggleExpand: () => void;
    isSelected: boolean;
    onToggleSelection: () => void;
    onDeleteFolder: () => void;
    onEditFolder: (updatedFolder: FolderListItem) => void;
    siblingFolderNames: Array<string>;
    groups: Map<string, string>;
    orgId: string;
};

const StyledTR = styled(Tr) <{ level: number }>`

    td {
        svg {
            margin-right: 5px ;
        }
        border-top-color: ${props => props.isSelected && props.theme.colors.highlight};
        border-bottom-color: ${props => props.isSelected && props.theme.colors.highlight};
    }

    &:last-child td{
        border-bottom: 1px solid ${props => props.isSelected ? props.theme.colors.highlight : props.theme.colors.greyContrastMediumLower} ;
    }

    /*to indent the children right we calculate the padding from the 'level prop' */
    td:first-child {
        padding-left: ${props => (props.level + 1) * 20}px;
        width: 60%;
        border-left-color: ${props => props.isSelected && props.theme.colors.highlight};
    }

    /* Action container */
    td:last-child {
        border-right-color: ${props => props.isSelected && props.theme.colors.highlight};
        svg {
            margin-right: 0;
        }
    }
`;

const DIV = styled.div`
    display: flex;
    align-items: center;
    width: max-content ;
    cursor: pointer;
`;

const FolderRow: FC<FolderRowProps> = props => {
    const theme: GmgTheme = useTheme();
    return (
        <StyledTR
            isSelected={props.isSelected}
            level={props.folder.level}
            onClick={props.onToggleSelection}
            isClickable
            data-testid="folder-row"
        >
            <td>
                <DIV onClick={(ev: any) => { ev.stopPropagation(); props.onToggleExpand(); }}>
                    {props.isLoading
                        ? <Spinner svgSize="14px" />
                        : props.folder.isExpanded
                            ? <IconArrowDropDown14 width='14px' height='14px' />
                            : <IconArrowRightSmall width='16px' height='16px' />
                    }
                    <IconFolderFilled color={theme.colors.greyContrastSemiHigh} width='16px' height='16px' />
                    <span className='px12_400_normal'>{props.folder.name}</span>
                </DIV>
            </td>
            <td className='invisibleSVG'>
                <DataManagementActions
                    folder={props.folder}
                    siblingFolderNames={props.siblingFolderNames}
                    onDeleteFolder={props.onDeleteFolder}
                    onEditFolder={props.onEditFolder}
                    groups={props.groups}
                    orgId={props.orgId}
                />
            </td>
        </StyledTR>
    );
};

export default FolderRow;